<template>
  <template v-if="!model.registerStatus">
    <a-input class="sms-input" v-model="model.phone" placeholder="请输入手机号" allow-clear size="large">
      <template #prepend>+86</template>
    </a-input>
    <a-input class="sms-input captcha-inpput" v-model="model.captchaCode" placeholder="请输入图形验证码" allow-clear size="large">
      <template #append>
        <img v-if="model.captchaPath" :src="model.captchaPath" class="captcha-img" @click="getCaptcha()" alt />
      </template>
    </a-input>
    <a-input class="sms-input" v-model="model.phoneCode" placeholder="请输入短信验证码" allow-clear size="large" id="smsInput">
      <template #append>
        <a-button type="text" @click="handleGetPhoneCode" :disabled="model.phoneCodeTimer!==null">{{ model.phoneCodeTimer==null?'获取验证码':`重新发送(${model.phoneCodeCountDown}s)` }}</a-button>
      </template>
    </a-input>
    <a-button type="primary" class="login-btn" size="large" @click="handleLogin">登录 / 注册</a-button>
  </template>
  <template v-if="model.registerStatus">
    <a-input class="sms-input" v-model="model.nickname" placeholder="请输入昵称" allow-clear size="large" />
    <a-input-password class="sms-input" v-model="model.password" placeholder="请输入密码" allow-clear size="large" />
    <a-input-password class="sms-input" v-model="model.passwordAgain" placeholder="请再次输入密码" allow-clear size="large" />
    <a-button type="primary" class="login-btn" size="large" @click="handleRegister">注册</a-button>
  </template>
</template>
      
<script setup>
import { reactive, getCurrentInstance, onMounted } from "vue";
import { v4 as uuidv4 } from "uuid";
import { useRouter } from "vue-router";
import md5 from "md5";
const baseUrl = getCurrentInstance().appContext.config.globalProperties.baseUrl;
const notification = getCurrentInstance().appContext.config.globalProperties.$notification;
const post = getCurrentInstance().appContext.config.globalProperties.post;
const storageLabel = getCurrentInstance().appContext.config.globalProperties.storageLabel;
const router = useRouter();
const model = reactive({
  phone: "", //手机号
  phoneRegister: "", //通过验证的手机号 反正获取手机号后进行修改
  captchaPath: null, //图形验证码地址
  captchaUuid: "", //图形验证码UID
  captchaCode: "", //图形验证码
  phoneCode: "", //手机验证码
  phoneCodeTimer: null, //定时任务
  phoneCodeCountDown: 60, //定时任务计时器
  registerStatus: false, //是否在注册状态
  nickname: "", //昵称,
  password: "", //密码
  passwordAgain: "", //再次输入密码
  inviteCode: router.currentRoute.value.query.p,
});
//获取图形验证码
function getCaptcha() {
  model.captchaUuid = uuidv4();
  model.captchaPath = `${baseUrl}/userInfo/captcha.jpg?uuid=${model.captchaUuid}`;
}
onMounted(() => {
  getCaptcha();
});
//获取短信验证码
function handleGetPhoneCode() {
  if (model.phoneCodeTimer != null) {
    return;
  }
  if (model.captchaCode === "") {
    notification.error({ title: "提醒", content: "请输入图形验证码!" });
    return;
  }
  if (model.phone === "") {
    notification.error({ title: "提醒", content: "请输入手机号!" });
    return;
  }
  post("/userInfo/getPhoneCode", { uuid: model.captchaUuid, captcha: model.captchaCode, phone: model.phone }).then((res) => {
    if (res.success) {
      model.phoneRegister = model.phone;
      //重新获取验证码倒计时
      model.phoneCodeTimer = setInterval(() => {
        model.phoneCodeCountDown--;
        if (model.phoneCodeCountDown == 0) {
          clearInterval(model.phoneCodeTimer);
          model.phoneCodeCountDown = 60;
          model.phoneCodeTimer = null;
        }
      }, 1000);
      //测试
      model.phoneCode = res.data.phoneCode;
      model.phoneCodeUuid = res.data.phoneCodeUuid;
    }
  });
}
//登录按钮
function handleLogin() {
  if (model.phoneCode === "") {
    notification.error({ title: "提醒", content: "请填写短信验证码!" });
    return;
  }
  if (model.phone === "" || model.phone !== model.phoneRegister) {
    notification.error({ title: "提醒", content: "请正确填写手机号或重新获取验证码!" });
    return;
  }
  post("/userInfo/phoneLogin", {
    uuid: model.phoneCodeUuid,
    phoneCode: model.phoneCode,
    phone: model.phone,
    loginWay:'web',
  }).then((res) => {
    if (res.success) {
      if (res.data.needRegister) {
        model.registerStatus = true;
      } else {
        localStorage.setItem(storageLabel() , res.data.userKey);
        location.reload();
      }
    }
  });
}

//注册
function handleRegister() {
  if (model.nickname === "") {
    notification.error({ title: "提醒", content: "请填写昵称!" });
    return;
  }
  if (model.password === "" || model.passwordAgain === "") {
    notification.error({ title: "提醒", content: "请填写密码!" });
    return;
  }
  if (model.password !== model.passwordAgain) {
    notification.error({ title: "提醒", content: "密码前后不一致!" });
    return;
  }
  post("/userInfo/register", {
    phone: model.phone,
    userPassword: md5(model.password),
    nickname: model.nickname,
    beInvitedCode: model.inviteCode,
    registerWay:'web'
  }).then((res) => {
    if (res.success) {
      localStorage.setItem(storageLabel() , res.data);
      location.reload();
    }
  });
}
</script>
<style >
.captcha-inpput .arco-input-append {
  border-left: 0;
}
</style>
<style lang="scss" scoped>
.sms-input {
  width: 100%;
  margin-bottom: 24px;
}
.captcha-img {
  height: 26px;
  cursor: pointer;
}
.login-btn {
  margin-top: 48px;
  width: 100%;
}
</style>
      